import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { v4 as uuidv4 } from 'uuid';

export type Device = { id: string; label: string; createdAt: number };
export type Tx = { id: string; to: string; amount: number; nonce: number; timestamp: number; status: 'pending' | 'approved' | 'rejected' };

type State = {
  walletId: string | null;
  devices: Device[];
  balance: number;
  txs: Tx[];
  initializeFromStorage: () => Promise<void>;
  createWallet: (primaryDeviceLabel: string) => void;
  addDevice: (label: string, id: string) => void;
  recordTx: (tx: Omit<Tx, 'status'> & { status?: Tx['status'] }) => void;
  setTxStatus: (id: string, status: Tx['status']) => void;
  deposit: (amount: number) => void;
};

export const useWalletStore = create<State>()(persist((set, get) => ({
  walletId: null,
  devices: [],
  balance: 1000,
  txs: [],
  async initializeFromStorage() { /* state restored by persist */ },
  createWallet(primaryDeviceLabel: string) {
    const id = uuidv4();
    const deviceId = uuidv4();
    set({ walletId: id, devices: [{ id: deviceId, label: primaryDeviceLabel, createdAt: Date.now() }] });
  },
  addDevice(label: string, id: string) {
    set({ devices: [...get().devices, { id, label, createdAt: Date.now() }] });
  },
  recordTx(tx) {
    set({ txs: [{ ...tx, status: tx.status ?? 'pending' }, ...get().txs] });
  },
  setTxStatus(id, status) {
    set({ txs: get().txs.map(t => t.id === id ? { ...t, status } : t) });
  },
  deposit(amount) {
    set({ balance: get().balance + amount });
  },
}), { name: 'dbw-store' }));


